package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.devices.create_new_region


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CreateRegion(
    @SerialName("departmentId")
    val departmentId: String?,
    @SerialName("id")
    val id: String?,
    @SerialName("mod_ver")
    val modVer: Int?,
    @SerialName("name")
    val name: String?,
    @SerialName("__typename")
    val typename: String?
)